module.exports = __webpack_public_path__ + "static/img/悬浮4.6299851.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/smeltingEquipment/悬浮4.jpg
// module id = Dbwz
// module chunks = 1